export default __webpack_public_path__ + "a51d0a294d8ebaa89504adc7a601b782.svg";